import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3a6fbbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "template-edit-form" }
const _hoisted_2 = { class: "template-edit-form_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "template-edit-form_title_text" }, "Редактирование шаблона", -1))
const _hoisted_4 = { class: "template-edit-form_title_controls" }

import { onBeforeMount, PropType, ref, watch } from "vue";
import { ParametersTemplateModel } from "../models";
import { TaskParametersTable, TaskParametersInput } from "../components";
import { TaskParameterModel, TaskParameterTypeEnum } from "@/components";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmInput,
} from "tir-components";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'template-edit-form',
  props: {
  /**Тип настройки */
  type: { type: Number as PropType<TaskParameterTypeEnum> },
  /**Редактируемый параметр */
  template: { type: Object as PropType<ParametersTemplateModel> },
  /**Заголовок параметра */
  title: { type: String, default: "" },
  /**Список шаблонов */
  templates: { type: Array as PropType<ParametersTemplateModel[]> },
  /**Имя области */
  namespaceName: { type: String },
},
  emits: ["save", "cancel"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Локальный редактируемый шаблон */
const innerTemplate = ref<ParametersTemplateModel>();
/**Объект для демонстрации добавления тега */
const upsertParameter = ref(new TaskParameterModel());
/**Список шаблонов */
const parameters = ref<TaskParameterModel[]>([]);

/**Отслеживание изменений шаблона из параметров */
watch(() => props.template, setTemplate, { deep: true });

/**Перед рендером */
onBeforeMount(() => setTemplate());

/**Установка локального шаблона */
function setTemplate() {
  innerTemplate.value = new ParametersTemplateModel(props.template);
  parameters.value = innerTemplate.value.ParsedData.map(
    (x) => new TaskParameterModel({ ...x, InUse: false }),
  );
}
/**Редактирование элемента */
const onUpsertParameter = (_parameter: TaskParameterModel) => {
  if (_parameter.Id) {
    const parameter = parameters.value.find((x) => x.Id == _parameter.Id);
    parameter.Name = _parameter.Name;
    parameter.Color = _parameter.Color;
  } else {
    parameters.value.unshift(_parameter);
  }
  upsertParameter.value = new TaskParameterModel({ Color: upsertParameter.value.Color });
};
/**Сохранить шаблон */
const saveTemplate = () => {
  innerTemplate.value.Data = JSON.stringify(parameters.value);
  setTimeout(() => emit("save", innerTemplate.value));
};
/**Отмена редактирования */
const cancelEditing = () => {
  setTimeout(() => emit("cancel"));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(TirPmButton), {
          size: _unref(TirPmButtonSizeEnum).Small,
          variant: _unref(TirPmButtonVariantEnum).PrimaryState,
          onClick: saveTemplate
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Сохранить ")
          ]),
          _: 1
        }, 8, ["size", "variant"]),
        _createVNode(_unref(TirPmButton), {
          size: _unref(TirPmButtonSizeEnum).Small,
          variant: _unref(TirPmButtonVariantEnum).SecondaryState,
          onClick: cancelEditing
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Отмена ")
          ]),
          _: 1
        }, 8, ["size", "variant"])
      ])
    ]),
    _createVNode(_unref(TirPmInput), {
      modelValue: innerTemplate.value.Name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((innerTemplate.value.Name) = $event)),
      "is-with-hint": false,
      label: "Название шаблона"
    }, null, 8, ["modelValue"]),
    _createVNode(_unref(TaskParametersInput), {
      upsertParameter: upsertParameter.value,
      "onUpdate:upsertParameter": _cache[1] || (_cache[1] = ($event: any) => ((upsertParameter).value = $event)),
      "hide-templates": "",
      type: __props.type,
      templates: __props.templates,
      ignoreParameters: parameters.value,
      title: __props.title,
      onUpsert: onUpsertParameter
    }, null, 8, ["upsertParameter", "type", "templates", "ignoreParameters", "title"]),
    _createVNode(_unref(TaskParametersTable), {
      parameters: parameters.value,
      type: __props.type,
      namespaceName: __props.namespaceName
    }, null, 8, ["parameters", "type", "namespaceName"])
  ]))
}
}

})